import React, { useContext } from 'react';
import TaskPage from './Pages/TaskPage';
import './App.css';
import Cookies from 'js-cookie';
import { BrowserRouter, Route } from 'react-router-dom';
import { Container, Button, Divider } from 'semantic-ui-react';
import HomePageFamilyMember from './Pages/HomePageFamilyMember';
import { AppState } from './context';
import Summary from './Pages/Summary'
import EditTask from './Pages/EditTask';
import TopMenu from './Pages/TopMenu';
import Notes from './Pages/Notes';
import HomePageCaregiver from './Pages/Caregiver/HomePageCaregiver';
import AddNotes from './Pages/Caregiver/AddNotes';
import Senior from './Pages/ProfileCreation/Senior';
import Caregiver from './Pages/ProfileCreation/Caregiver';
import FamilyProfile from './Pages/FamilyMemberProfile/FamilyProfile';
import AddFamilyMemberView from './Pages/FamilyMemberProfile/AddFamilyMemberView';
import ManageFamilyView from './Pages/FamilyMemberProfile/ManageFamilyView';
import SecondaryFamHomepage from './Pages/SecondaryFam/SecondaryFamHomepage';
import SecondTaskPage from './Pages/SecondaryFam/SecondTaskPage';
import LoginF from './Pages/SecondaryFam/LoginF';
import Login from './Pages/Caregiver/Login';
import Home from './Pages/LandingPage';
import Blog from './Pages/Blog'
import ZipCodeFinder from './Pages/ZipCodeFinder'
import Admin from './Pages/Agency/Admin'
import Tutorial from './Pages/Tutorial'
import Recommended from './Pages/RecommendedTasks';
import Signup from './Pages/Signup'
import LoginForm from './Pages/LoginGB';
import Ques from './Pages/ProfileCreation/Carequestion';
import Ques2 from './Pages/ProfileCreation/Famquestion';
import Privacy from './Privacy';
import Eacharticle from './Pages/Eacharticle';
import LoginAdmin from './Pages/Agency/Login'
import AdminTasks from './Pages/Agency/AdminTasks';
import RequestDemo from './Pages/RequestDemo'
import AdminNotes from './Pages/Agency/AdminNotes';

const withMenu = (page) => {

  return (
    <div>
      <TopMenu />
      <Container>
        {page}
      </Container>
    </div>
  )
};

function App() {
  const someContext = useContext(AppState);
  const { user, admin } = someContext;
  return (
    <BrowserRouter>
      <Route exact path="/samarth/admin" render={() => {
        if (admin == 'Samarth' || (Cookies.get('logged') == 'Samarth')) {
          return <Admin inst={"Samarth"} />
        }
        else { return window.location.assign('/agency/Samarth/login') }
      }} />
      <Route exact path="/Samarth/admin/:id/:senior" render={() => {
        
        if (admin == 'Samarth' || (Cookies.get('logged') == 'Samarth')) {
          return <AdminTasks />
        }
        else { return window.location.assign('/agency/Samarth/login') }
      }} />
      <Route exact path="/Samarth/admin/:id/:senior/notes" render={() => {
        
        if (admin == 'Samarth' || (Cookies.get('logged') == 'Samarth')) {
          return <AdminNotes />
        }
        else { return window.location.assign('/agency/Samarth/login') }
      }} />
      <Route exact path="/agency/:inst/login" render={() => <LoginAdmin />} />
      <Route exact path="/familymembers" render={() => <HomePageFamilyMember />} />
      <Route exact path="/privacy" render={() => <Privacy />} />
      <Route exact path="/familymembers/register/careques/:userid" render={() => <Ques />} />
      <Route exact path="/samarth/familymembers/register/careques/:userid" render={() => <Ques inst={"Samarth"} />} />
      <Route exact path="/familymembers/register/famques/:userid" render={() => <Ques2 />} />
      <Route exact path="/samarth/familymembers/register/famques/:userid" render={() => <Ques2 inst={"Samarth"} />} />
      <Route exact path="/familymembers/register/senior/:userid/:bool" render={() => <Senior user={user} />} />
      <Route exact path="/samarth/familymembers/register/senior/:userid/:bool" render={() => <Senior user={user} inst={"Samarth"} />} />
      <Route exact path="/familymembers/add/secondfam/:userid/:bool" render={() => <AddFamilyMemberView />} />
      <Route exact path="/samarth/familymembers/add/secondfam/:userid/:bool" render={() => <AddFamilyMemberView inst={"Samarth"} />} />
      <Route exact path="/familymembers/register/caregiver/:userid/:bool" render={() => <Caregiver userr={user}></Caregiver>} ></Route>
      <Route exact path="/samarth/familymembers/register/caregiver/:userid/:bool" render={() => <Caregiver userr={user} inst={"Samarth"}></Caregiver>} ></Route>
      <Route exact path="/familymembers/add/caregiver/:userid/:bool" render={() => <Caregiver userr={user}></Caregiver>} ></Route>
      <Route exact path="/familymembers/register/recommended/:userid" render={() => <Recommended />} />
      <Route exact path="/samarth/familymembers/register/recommended/:userid" render={() => <Recommended inst={"Samarth"} />} />
      <Route exact path="/tutorial" render={() => <Tutorial />} />
      <Route exact path="/blog" render={() => <Blog />} />
      <Route exact path="/blog/:articleID" render={() => <Eacharticle></Eacharticle>} />
      {/* <Route exact path="/blog/:key" render={()=><Article />} /> */}
      <Route exact path="/login" render={() => <LoginForm />} />
      <Route exact path="/samarth/login" render={() => <LoginForm inst={"Samarth"} />} />
      <Route exact path="/" render={() => <Home />} />
      <Route exact path="/familymembers/summary/:userid" render={() => ((<Summary />))} />
      <Route exact path="/familymembers/Notes/:userid" render={() => ((<Notes />))} />
      <Route exact path="/familymembers/profile/:userid" render={() => ((<FamilyProfile />))} />
      <Route exact path="/familymembers/edit/:taskid" render={() => withMenu(<EditTask />)} />
      <Route exact path="/familymembers/:userid" render={() => withMenu(<TaskPage />)} />
      <Route exact path="/viewfamily/:userid" render={() => <SecondaryFamHomepage />} />
      <Route exact path="/viewfamily" render={() => <LoginF />} />
      <Route exact path="/caregivers" render={() => <Login />} />
      <Route exact path="/samarth/caregivers" render={() => <Login inst="Samarth" />} />

      {/* <Route exact path="/samarth/caregivers" render={() => <LoginForm inst={"Samarth"} />} /> */}
      <Route exact path="/caregivers/:userid" render={() => <HomePageCaregiver />} />
      <Route exact path="/familymembers/manageview/:userid" render={() => <ManageFamilyView />} />
      <Route exact path="/viewfamily/createtask/:userid" render={() => <SecondTaskPage />} />
      <Route exact path="/caregivers/addNote/:caregiverID" render ={()=> <AddNotes />} />
      <Route exact path="/signup" render ={()=> <Signup />} />
      <Route exact path="/samarth/signup" render ={()=> <Signup inst={"Samarth"}/>} />
      <Route exact path ="/zipcoderesources" render = {() => <ZipCodeFinder />} />


      <Route exact path="/contactus" render ={()=> <RequestDemo />} />

    </BrowserRouter>
  );


}

export default App;